import React from "react";
import { Route, Routes } from "react-router-dom";
import Login from "../pages/auth/login/Login";
// import PasswordRecovery from "../pages/auth/passwordrecovery/PasswordRecovery";
// import SetPassword from "../pages/auth/setpassword/SetPassword";
import Dashboard from "../pages/dashboard/Dashboard";
// import Devices from "../pages/devices/Devices";
// import DevicesAtLocation from "../pages/locations/DevicesAtLocation";
// import DevicesGroup from "../pages/devices/DevicesGroup";
// import DevicesAtPlanogram from "../pages/planograms/devices/DevicesAtPlanogram";
// import Device from "../pages/devices/Device";
import { NotFoundPage } from '../pages/forbidden/ForbiddenPage';
import MainLayout from "../pages/layout/MainLayout";
// import Locations from "../pages/locations/Locations";
// import Merchants from "../pages/merchants/Merchants";
// import Operators from "../pages/operators/Operators";
import Planograms from "../pages/planograms/Planograms";
import PlanogramDetails from "../pages/planograms/details/PlanogramDetails";
// import Products from "../pages/products/Products";
// import Terminals from "../pages/terminals/Terminals";
// import TerminalsEdit from "../pages/terminals/TerminalsEdit";
// import User from "../pages/users/User";
// import Users from "../pages/users/Users";
import ProtectedRoute from "./ProtectedRoute";
import RequirePermission from './RequirePermission';

import { AccessLevel, useAuth } from "../hook/useAuth";
import { featureFlags } from "../utils/featureFlags";
import CashOperationsHistory from "../pages/cashoperations/CashOperationsHistory";
import DeviceCashOperations from "../pages/cashoperations/DeviceCashOperations";
import Events from "../pages/events/Events";
import ProductDetails from "../pages/products/ProductDetails";
import Transactions from "../pages/transactions/Transactions";
import UserProfile from "../pages/users/UserProfile";
import WarehouseStockDetails from "../pages/products/WarehouseStockDetails";

const Devices = React.lazy(() => import("../pages/devices/Devices"));
const DevicesAtLocation = React.lazy(() => import("../pages/locations/DevicesAtLocation"));
const DevicesGroup = React.lazy(() => import("../pages/devices/DevicesGroup"));
const DevicesAtPlanogram = React.lazy(() => import("../pages/planograms/devices/DevicesAtPlanogram"));
const Device = React.lazy(() => import("../pages/devices/Device"));
const Merchants = React.lazy(() => import("../pages/merchants/Merchants"));
const RouteHistoryDetails = React.lazy(() => import("../pages/routes/RouteHistoryDetails"));
const Operators = React.lazy(() => import("../pages/operators/Operators"));

;
const Terminals = React.lazy(() => import("../pages/terminals/Terminals"));
const TerminalsEdit = React.lazy(() => import("../pages/terminals/TerminalsEdit"));
const Locations = React.lazy(() => import("../pages/locations/Locations"));
const Products = React.lazy(() => import("../pages/products/Products"));
const PasswordRecovery = React.lazy(() => import("../pages/auth/passwordrecovery/PasswordRecovery"));
const SetPassword = React.lazy(() => import("../pages/auth/setpassword/SetPassword"));
const User = React.lazy(() => import("../pages/users/User"));
const Users = React.lazy(() => import("../pages/users/Users"));
const PlanogramPreviewPage = React.lazy(() => import("../pages/planograms/details/PlanogramPreviewPage"));
const PlanogramPendingDetails = React.lazy(() => import("../pages/planograms/pendings/PlanogramPendingDetails"));
const ReportsConfig = React.lazy(() => import("../pages/reports/ReportsConfig"));
const ReportSales = React.lazy(() => import("../pages/reports/ReportSales"));
const ReportSalesByProduct = React.lazy(() => import("../pages/reports/ReportSalesByProduct"));
const ReportSalesByPaymentMethod = React.lazy(() => import("../pages/reports/ReportSalesByPaymentMethod"));
const ReportsStock = React.lazy(() => import("../pages/reports/ReportsStock"));
const SalesReport = React.lazy(() => import("../pages/reports/salesreport/SalesReport"));
const RoutesPage = React.lazy(() => import("../pages/routes/Routes"));
const RouteDetails = React.lazy(() => import("../pages/routes/RouteDetails"));
const LocationDetails = React.lazy(() => import("../pages/routes/LocationDetails"));
const SoftwareUpdates = React.lazy(() => import("../pages/softwareupdates/SoftwareUpdates"));
const SSORedirect = React.lazy(() => import("../pages/auth/sso-redirect/SSORedirect"));

const StockCheck = React.lazy(() => import("../pages/products/StockDocuments/StockCheck"));
const StockTransfer = React.lazy(() => import("../pages/products/StockDocuments/StockTransfer"));
const StockIn = React.lazy(() => import("../pages/products/StockDocuments/StockIn"));
const StockOut = React.lazy(() => import("../pages/products/StockDocuments/StockOut"));

const StockInCreateView = React.lazy(() => import("../pages/products/StockDocuments/views/StockInCreateView"));
const StockInEditView = React.lazy(() => import("../pages/products/StockDocuments/views/StockInEditView"));
const StockInPreviewView = React.lazy(() => import("../pages/products/StockDocuments/views/StockInPreviewView"));
const SparePartDetails = React.lazy(() => import("../pages/products/SparePartDetails"));

const StockOutCreateView = React.lazy(() => import("../pages/products/StockDocuments/views/StockOutCreateView"));
const StockOutEditView = React.lazy(() => import("../pages/products/StockDocuments/views/StockOutEditView"));
const StockOutPreviewView = React.lazy(() => import("../pages/products/StockDocuments/views/StockOutPreviewView"));

const StockTransferCreateView = React.lazy(() => import("../pages/products/StockDocuments/views/StockTransferCreateView"));
const StockTransferEditView = React.lazy(() => import("../pages/products/StockDocuments/views/StockTransferEditView"));
const StockTransferPreviewView = React.lazy(() => import("../pages/products/StockDocuments/views/StockTransferPreviewView"));

const StockInSummary = React.lazy(() => import("../pages/products/StockSummary/StockInSummary"));
const StockOutSummary = React.lazy(() => import("../pages/products/StockSummary/StockOutSummary"));
const StockTransferSummary = React.lazy(() => import("../pages/products/StockSummary/StockTransferSummary"));
const StockCheckSummary = React.lazy(() => import("../pages/products/StockSummary/StockCheckSummary"));

const StockCheckEditView = React.lazy(() => import("../pages/products/StockDocuments/views/StockCheckEditView"));
const StockCheckPreviewView = React.lazy(() => import("../pages/products/StockDocuments/views/StockCheckPreviewView"));
const StockCheckCreateView = React.lazy(() => import("../pages/products/StockDocuments/views/StockCheckCreateView"));

const HomeRedirect = () => {
    const { getAccessLevel, isUserInAnyRole } = useAuth();
    const accessLevel = getAccessLevel();
    if (accessLevel === AccessLevel.MERCHANT) {
        if (isUserInAnyRole(['DASHBOARD_READ', 'DASHBOARD_WRITE'])) {
            return <Dashboard />;
        } else if (isUserInAnyRole(['LOCATIONS_READ', 'LOCATIONS_WRITE'])) {
            return <Locations />;
        } else if (isUserInAnyRole(['TERMINALS_READ', 'TERMINALS_WRITE'])) {
            return <Terminals />;
        } else if (isUserInAnyRole(['DEVICES_READ', 'DEVICES_WRITE'])) {
            return <Devices />;
        } else if (isUserInAnyRole(['PLANOGRAMS_READ', 'PLANOGRAMS_WRITE'])) {
            return <Planograms />;
        } else if (isUserInAnyRole(['PRODUCTS_READ', 'PRODUCTS_WRITE'])) {
            return <Products />;
        } else if (isUserInAnyRole(['CASH_OPERATIONS_READ', 'CASH_OPERATIONS_WRITE'])) {
            return <CashOperationsHistory />;
        } else if (isUserInAnyRole(['ROUTES_READ', 'ROUTES_WRITE'])) {
            return <RoutesPage />;
        } else if (isUserInAnyRole(['REPORTS_READ', 'REPORTS_WRITE'])) {
            return <ReportsConfig />;
        } else if (isUserInAnyRole(['USERS_READ', 'USERS_WRITE'])) {
            return <Users />;
        } else if (isUserInAnyRole(['EVENTS_READ', 'EVENTS_WRITE'])) {
            return <Events />;
        } else if (isUserInAnyRole(['TRANSACTIONS_READ', 'TRANSACTIONS_WRITE'])) {
            return <Transactions />;
        }
        return <NotFoundPage />
    } else {
        return (
            <RequirePermission permissions={["TERMINALS_READ", "TERMINALS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.OPERATOR, AccessLevel.ADMIN]}>
                <Terminals />
            </RequirePermission>
        );
    }
};

const Routing = () => {
    
    return (
        <Routes>
            <Route path="/auth/login" element={<Login />} />
            <Route path="/auth/password-recovery" element={<PasswordRecovery />} />
            <Route path="/auth/set-password/:token" element={<SetPassword />} />
            <Route path="/auth/sso-redirect" element={<ProtectedRoute><SSORedirect /></ProtectedRoute>} />
            <Route element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
                <Route index path="/" element={<HomeRedirect />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/terminals" element={
                    <RequirePermission permissions={["TERMINALS_READ", "TERMINALS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.OPERATOR, AccessLevel.ADMIN]}>
                        <Terminals />
                    </RequirePermission>
                } />
                <Route path="/terminals/:terminalId/edit/" element={
                    <RequirePermission permissions={["TERMINALS_READ", "TERMINALS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.OPERATOR, AccessLevel.ADMIN]}>
                        <TerminalsEdit />
                    </RequirePermission>
                } />
                <Route path="/locations" element={
                    <RequirePermission permissions={["LOCATIONS_READ", "LOCATIONS_WRITE"]} accessLevels={[AccessLevel.MERCHANT]}>
                        <Locations />
                    </RequirePermission>
                } />
                <Route
                    path="/locations/map"
                    element={
                        <RequirePermission
                            permissions={[
                                'LOCATIONS_READ',
                                'LOCATIONS_WRITE'
                            ]}
                            accessLevels={[
                                AccessLevel.MERCHANT
                            ]}
                        >
                            <Locations />
                        </RequirePermission>
                    }
                />
                <Route path="/locations/:locationId/devices" element={
                    <RequirePermission permissions={["LOCATIONS_READ", "LOCATIONS_WRITE"]} accessLevels={[AccessLevel.MERCHANT]}>
                        <DevicesAtLocation />
                    </RequirePermission>
                } />
                <Route path="/devices" element={
                    <RequirePermission permissions={["DEVICES_READ", "DEVICES_WRITE"]} accessLevels={[AccessLevel.MERCHANT]}>
                        <Devices />
                    </RequirePermission>
                } />
                <Route path="/devices/:deviceId" element={
                    <RequirePermission permissions={["DEVICES_READ", "DEVICES_WRITE"]} accessLevels={[AccessLevel.MERCHANT]}>
                        <Device />
                    </RequirePermission>
                } />
                <Route path="/device-groups/:groupId" element={
                    <RequirePermission permissions={["DEVICES_READ", "DEVICES_WRITE"]} accessLevels={[AccessLevel.MERCHANT]}>
                        <DevicesGroup />
                    </RequirePermission>
                } />
                <Route path="/planograms" element={
                    <RequirePermission permissions={["PLANOGRAMS_READ", "PLANOGRAMS_WRITE"]} accessLevels={[AccessLevel.MERCHANT]}>
                        <Planograms />
                    </RequirePermission>
                } />
                <Route
                    path="/planograms/pendings"
                    element={
                        <RequirePermission
                            permissions={[
                                'PLANOGRAMS_READ',
                                'PLANOGRAMS_WRITE'
                            ]}
                            accessLevels={[
                                AccessLevel.MERCHANT
                            ]}
                        >
                            <Planograms />
                        </RequirePermission>
                    }
                />
                <Route path="/planograms/:planogramId/devices" element={
                    <RequirePermission permissions={["PLANOGRAMS_READ", "PLANOGRAMS_WRITE"]} accessLevels={[AccessLevel.MERCHANT]}>
                        <DevicesAtPlanogram />
                    </RequirePermission>
                } />
                <Route path="/planogram-pendings/details/:planogramId" element={
                    <RequirePermission permissions={["PLANOGRAMS_READ", "PLANOGRAMS_WRITE"]} accessLevels={[AccessLevel.MERCHANT]}>
                        <PlanogramPendingDetails />
                    </RequirePermission>
                } />
                <Route path="/planograms/create/:rows/:columns/:name/visual" element={
                    <RequirePermission permissions={["PLANOGRAMS_READ", "PLANOGRAMS_WRITE"]} accessLevels={[AccessLevel.MERCHANT]}>
                        <PlanogramDetails mode="NEW" />
                    </RequirePermission>
                } />
                <Route path="/planograms/edit/:planogramId/visual" element={
                    <RequirePermission permissions={["PLANOGRAMS_READ", "PLANOGRAMS_WRITE"]} accessLevels={[AccessLevel.MERCHANT]}>
                        <PlanogramDetails mode="EDIT" />
                    </RequirePermission>
                } />

                <Route path="/planograms/view/:planogramId" element={
                    <RequirePermission permissions={["PLANOGRAMS_READ", "PLANOGRAMS_WRITE"]} accessLevels={[AccessLevel.MERCHANT]}>
                        <PlanogramPreviewPage />
                    </RequirePermission>
                } />


                <Route path="/products" element={
                    <RequirePermission permissions={["PRODUCTS_READ", "PRODUCTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <Products />
                    </RequirePermission>
                } />

                <Route path="/products/:productId/details/" element={
                    <RequirePermission permissions={["PRODUCTS_READ", "PRODUCTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <ProductDetails />
                    </RequirePermission>
                } />

                <Route path="/products/spare-parts/:sparePartId/details" element={
                    <RequirePermission permissions={["PRODUCTS_READ", "PRODUCTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <SparePartDetails />
                    </RequirePermission>
                } />

                <Route path="/products/stock-levels" element={
                    <RequirePermission permissions={["PRODUCTS_READ", "PRODUCTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <Products />
                    </RequirePermission>
                } />

                <Route path="/products/stock-documents" element={
                    <RequirePermission permissions={["PRODUCTS_READ", "PRODUCTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <Products />
                    </RequirePermission>
                } />

                <Route path="/products/warehouse-configuration" element={
                    <RequirePermission permissions={["PRODUCTS_READ", "PRODUCTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <Products />
                    </RequirePermission>
                } />

                <Route path="/products/suppliers" element={
                    <RequirePermission permissions={["PRODUCTS_READ", "PRODUCTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <Products />
                    </RequirePermission>
                } />

                <Route path="/products/product-category" element={
                    <RequirePermission permissions={["PRODUCTS_READ", "PRODUCTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <Products />
                    </RequirePermission>
                } />

                <Route path="/products/configuration" element={
                    <RequirePermission permissions={["PRODUCTS_READ", "PRODUCTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <Products />
                    </RequirePermission>
                } />

                <Route path="/products/stock-documents/stock-transfer" element={
                    <RequirePermission permissions={["PRODUCTS_READ", "PRODUCTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <StockTransfer onBack={() => window.history.back()} />
                    </RequirePermission>
                } />

                <Route path="/products/stock-documents/stock-in" element={
                    <RequirePermission permissions={["PRODUCTS_READ", "PRODUCTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <StockInCreateView />
                    </RequirePermission>
                } />

                <Route path="/products/stock-documents/stock-in/new" element={
                    <RequirePermission permissions={["PRODUCTS_READ", "PRODUCTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <StockInCreateView />
                    </RequirePermission>
                } />

                <Route path="/products/stock-documents/stock-in/:documentId/edit" element={
                    <RequirePermission permissions={["PRODUCTS_READ", "PRODUCTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <StockInEditView />
                    </RequirePermission>
                } />

                <Route path="/products/stock-documents/stock-in/:documentId/preview" element={
                    <RequirePermission permissions={["PRODUCTS_READ", "PRODUCTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <StockInPreviewView />
                    </RequirePermission>
                } />

                <Route path="/products/stock-documents/stock-out" element={
                    <RequirePermission permissions={["PRODUCTS_READ", "PRODUCTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <StockOutCreateView />
                    </RequirePermission>
                } />

                <Route path="/products/stock-documents/stock-out/new" element={
                    <RequirePermission permissions={["PRODUCTS_READ", "PRODUCTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <StockOutCreateView />
                    </RequirePermission>
                } />

                <Route path="/products/stock-documents/stock-out/:documentId/edit" element={
                    <RequirePermission permissions={["PRODUCTS_READ", "PRODUCTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <StockOutEditView />
                    </RequirePermission>
                } />

                <Route path="/products/stock-documents/stock-out/:documentId/preview" element={
                    <RequirePermission permissions={["PRODUCTS_READ", "PRODUCTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <StockOutPreviewView />
                    </RequirePermission>
                } />

                <Route path="/products/stock-documents/stock-transfer" element={
                    <RequirePermission permissions={["PRODUCTS_READ", "PRODUCTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <StockTransferCreateView />
                    </RequirePermission>
                } />

                <Route path="/products/stock-documents/stock-transfer/new" element={
                    <RequirePermission permissions={["PRODUCTS_READ", "PRODUCTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <StockTransferCreateView />
                    </RequirePermission>
                } />

                <Route path="/products/stock-documents/stock-transfer/:documentId/edit" element={
                    <RequirePermission permissions={["PRODUCTS_READ", "PRODUCTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <StockTransferEditView />
                    </RequirePermission>
                } />

                <Route path="/products/stock-documents/stock-transfer/:documentId/preview" element={
                    <RequirePermission permissions={["PRODUCTS_READ", "PRODUCTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <StockTransferPreviewView />
                    </RequirePermission>
                } />

                <Route path="/products/stock-documents/stock-check" element={
                    <RequirePermission permissions={["PRODUCTS_READ", "PRODUCTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <StockCheckCreateView />
                    </RequirePermission>
                } />

                <Route path="/products/stock-documents/stock-check/new" element={
                    <RequirePermission permissions={["PRODUCTS_READ", "PRODUCTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <StockCheckCreateView />
                    </RequirePermission>
                } />

                <Route path="/products/stock-documents/stock-check/:documentId/edit" element={
                    <RequirePermission permissions={["PRODUCTS_READ", "PRODUCTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <StockCheckEditView />
                    </RequirePermission>
                } />

                <Route path="/products/stock-documents/stock-check/:documentId/preview" element={
                    <RequirePermission permissions={["PRODUCTS_READ", "PRODUCTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <StockCheckPreviewView />
                    </RequirePermission>
                } />

                <Route path="/products/stock-documents/stock-check" element={
                    <RequirePermission permissions={["PRODUCTS_READ", "PRODUCTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <StockCheckCreateView />
                    </RequirePermission>
                } />

                <Route path="/products/stock-documents/stock-check/new" element={
                    <RequirePermission permissions={["PRODUCTS_READ", "PRODUCTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <StockCheckCreateView />
                    </RequirePermission>
                } />

                <Route path="/products/stock-documents/stock-check/:documentId/edit" element={
                    <RequirePermission permissions={["PRODUCTS_READ", "PRODUCTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <StockCheckEditView />
                    </RequirePermission>
                } />

                <Route path="/products/stock-documents/stock-check/:documentId/preview" element={
                    <RequirePermission permissions={["PRODUCTS_READ", "PRODUCTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <StockCheckPreviewView />
                    </RequirePermission>
                } />

                <Route path="/products/stock-summary/stock-check/:documentId" element={
                    <RequirePermission permissions={["PRODUCTS_READ", "PRODUCTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <StockCheckSummary />
                    </RequirePermission>
                } />
                
                <Route path="/products/stock-summary/stock-in/:documentId" element={
                    <RequirePermission permissions={["PRODUCTS_READ", "PRODUCTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <StockInSummary />
                    </RequirePermission>
                } />

                <Route path="/products/stock-summary/stock-out/:documentId" element={
                    <RequirePermission permissions={["PRODUCTS_READ", "PRODUCTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <StockOutSummary />
                    </RequirePermission>
                } />

                <Route path="/products/stock-summary/stock-transfer/:documentId" element={
                    <RequirePermission permissions={["PRODUCTS_READ", "PRODUCTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <StockTransferSummary />
                    </RequirePermission>
                } />

                <Route path="/products/import-templates" element={
                    <RequirePermission permissions={["PRODUCTS_READ", "PRODUCTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <Products />
                    </RequirePermission>
                } />

                <Route path="/products/stock-levels/warehouse/:warehouseId" element={
                    <RequirePermission
                        permissions={["PRODUCTS_READ", "PRODUCTS_WRITE"]}
                        accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}
                    >
                        <WarehouseStockDetails />
                    </RequirePermission>
                } />               

                <Route path="/cash-operations" element={
                    <RequirePermission permissions={["CASH_OPERATIONS_READ", "CASH_OPERATIONS_READ"]} accessLevels={[AccessLevel.MERCHANT]}>
                        <CashOperationsHistory />
                    </RequirePermission>
                } />

                {/* <Route
                    path="/cash-operations/history"
                    element={
                        <RequirePermission
                            permissions={[
                                'CASH_OPERATIONS_READ',
                                'CASH_OPERATIONS_WRITE'
                            ]}
                            accessLevels={[
                                AccessLevel.MERCHANT
                            ]}
                        >
                            <CashOperationsHistory />
                        </RequirePermission>
                    }
                /> */}

                <Route
                    path="/cash-operations/reconciliations"
                    element={
                        <RequirePermission
                            permissions={[
                                'CASH_OPERATIONS_READ',
                                'CASH_OPERATIONS_WRITE'
                            ]}
                            accessLevels={[
                                AccessLevel.MERCHANT
                            ]}
                        >
                            <CashOperationsHistory />
                        </RequirePermission>
                    }
                />

                <Route path="/cash-operations/:deviceId/:currency" element={
                    <RequirePermission permissions={["CASH_OPERATIONS_READ", "CASH_OPERATIONS_READ"]} accessLevels={[AccessLevel.MERCHANT]}>
                        <DeviceCashOperations />
                    </RequirePermission>
                } />
                <Route path="/events" element={
                    <RequirePermission permissions={["EVENTS_READ", "EVENTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT]}>
                        <Events />
                    </RequirePermission>
                } />

                <Route
                    path="/events/archive"
                    element={
                        <RequirePermission
                            permissions={[
                                'EVENTS_READ',
                                'EVENTS_WRITE'
                            ]}
                            accessLevels={[
                                AccessLevel.MERCHANT
                            ]}
                        >
                            <Events />
                        </RequirePermission>
                    }
                />

                <Route
                    path="/events/configuration"
                    element={
                        <RequirePermission
                            permissions={[
                                'EVENTS_READ',
                                'EVENTS_WRITE'
                            ]}
                            accessLevels={[
                                AccessLevel.MERCHANT
                            ]}
                        >
                            <Events />
                        </RequirePermission>
                    }
                />

                <Route
                    path="/routes"
                    element={
                        <RequirePermission
                            permissions={[
                                'ROUTES_READ',
                                'ROUTES_WRITE'
                            ]}
                            accessLevels={[
                                AccessLevel.MERCHANT
                            ]}
                        >
                            <RoutesPage />
                        </RequirePermission>
                    }
                />

                <Route
                    path="/routes/monitoring"
                    element={
                        <RequirePermission
                            permissions={[
                                'ROUTES_READ',
                                'ROUTES_WRITE'
                            ]}
                            accessLevels={[
                                AccessLevel.MERCHANT
                            ]}
                        >
                            <RoutesPage />
                        </RequirePermission>
                    }
                />

                <Route
                    path="/routes/history"
                    element={
                        <RequirePermission
                            permissions={[
                                'ROUTES_READ',
                                'ROUTES_WRITE'
                            ]}
                            accessLevels={[
                                AccessLevel.MERCHANT
                            ]}
                        >
                            <RoutesPage />
                        </RequirePermission>
                    }
                />

                <Route
                    path="/routes/attention-tasks"
                    element={
                        <RequirePermission
                            permissions={[
                                'ROUTES_READ',
                                'ROUTES_WRITE'
                            ]}
                            accessLevels={[
                                AccessLevel.MERCHANT
                            ]}
                        >
                            <RoutesPage />
                        </RequirePermission>
                    }
                />

                <Route
                    path="/routes/events"
                    element={
                        <RequirePermission
                            permissions={[
                                'ROUTES_READ',
                                'ROUTES_WRITE'
                            ]}
                            accessLevels={[
                                AccessLevel.MERCHANT
                            ]}
                        >
                            <RoutesPage />
                        </RequirePermission>
                    }
                />

                <Route
                    path="/routes/templates"
                    element={
                        <RequirePermission
                            permissions={[
                                'ROUTES_READ',
                                'ROUTES_WRITE'
                            ]}
                            accessLevels={[
                                AccessLevel.MERCHANT
                            ]}
                        >
                            <RoutesPage />
                        </RequirePermission>
                    }
                />

                <Route
                    path="/routes/configuration"
                    element={
                        <RequirePermission
                            permissions={[
                                'ROUTES_READ',
                                'ROUTES_WRITE'
                            ]}
                            accessLevels={[
                                AccessLevel.MERCHANT
                            ]}
                        >
                            <RoutesPage />
                        </RequirePermission>
                    }
                />

                <Route path="/routes/:routeId" element={
                    <RequirePermission permissions={["ROUTES_READ", "ROUTES_WRITE"]} accessLevels={[AccessLevel.MERCHANT]}>
                        <RouteDetails />
                    </RequirePermission>
                } />
                <Route path="/routes/history/:routeId" element={
                    <RequirePermission permissions={["ROUTES_READ", "ROUTES_WRITE"]} accessLevels={[AccessLevel.MERCHANT]}>
                        <RouteHistoryDetails />
                    </RequirePermission>
                } />
                <Route path="/routes/:routeId/locations/:locationId" element={
                    <RequirePermission permissions={["ROUTES_READ", "ROUTES_WRITE"]} accessLevels={[AccessLevel.MERCHANT]}>
                        <LocationDetails />
                    </RequirePermission>
                } />

                <Route path="/transactions" element={
                    <RequirePermission permissions={["TRANSACTIONS_READ", "TRANSACTIONS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN, AccessLevel.OPERATOR]}>
                        <Transactions />
                    </RequirePermission>
                } />

                <Route path="/users" element={
                    <RequirePermission permissions={["USERS_READ", "USERS_WRITE"]} accessLevels={[AccessLevel.ADMIN, AccessLevel.OPERATOR, AccessLevel.MERCHANT]}>
                        <Users />
                    </RequirePermission>
                } />
                <Route
                    path="/users/profiles"
                    element={
                        <RequirePermission
                            permissions={[
                                'USERS_READ',
                                'USERS_WRITE'
                            ]}
                            accessLevels={[
                                AccessLevel.ADMIN,
                                AccessLevel.OPERATOR,
                                AccessLevel.MERCHANT
                            ]}
                        >
                            <Users />
                        </RequirePermission>
                    }
                />
                <Route path="/users/edit/:userId" element={
                    <RequirePermission permissions={["USERS_READ", "USERS_WRITE"]} accessLevels={[AccessLevel.ADMIN, AccessLevel.OPERATOR, AccessLevel.MERCHANT]}>
                        <User viewMode="EDIT" />
                    </RequirePermission>
                } />
                <Route path="/users/new" element={
                    <RequirePermission permissions={["USERS_WRITE"]} accessLevels={[AccessLevel.ADMIN, AccessLevel.OPERATOR, AccessLevel.MERCHANT]}>
                        <User viewMode="NEW" />
                    </RequirePermission>
                } />
                <Route path="/profiles/new" element={
                    <RequirePermission permissions={["USERS_WRITE"]} accessLevels={[AccessLevel.MERCHANT]}>
                        <UserProfile viewMode="NEW" />
                    </RequirePermission>
                } />
                <Route path="/profiles/edit/:profileId" element={
                    <RequirePermission permissions={["USERS_WRITE"]} accessLevels={[AccessLevel.MERCHANT]}>
                        <UserProfile viewMode="EDIT" />
                    </RequirePermission>
                } />
                <Route path="/operators" element={
                    <RequirePermission permissions={["OPERATORS_READ", "OPERATORS_WRITE"]} accessLevels={[AccessLevel.ADMIN]}>
                        <Operators />
                    </RequirePermission>
                } />
                <Route path="/merchants" element={
                    <RequirePermission permissions={["MERCHANTS_READ", "MERCHANTS_WRITE"]} accessLevels={[AccessLevel.ADMIN, AccessLevel.OPERATOR]}>
                        <Merchants />
                    </RequirePermission>
                } />
                <Route path="/reports" element={
                    <RequirePermission permissions={["REPORTS_READ", "REPORTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <ReportsConfig />
                    </RequirePermission>
                } />
                <Route path="/reports/sales" element={
                    <RequirePermission permissions={["REPORTS_READ", "REPORTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <ReportSales />
                    </RequirePermission>
                } />
                <Route path="/reports/sales/by-product" element={
                    <RequirePermission permissions={["REPORTS_READ", "REPORTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <ReportSalesByProduct />
                    </RequirePermission>
                } />
                <Route path="/reports/sales/by-payment-method" element={
                    <RequirePermission permissions={["REPORTS_READ", "REPORTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <ReportSalesByPaymentMethod />
                    </RequirePermission>
                } />
                <Route path="/reports/sales-report" element={
                    <RequirePermission permissions={["REPORTS_READ", "REPORTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        {featureFlags.isEnabled('SALES_REPORT_V1') ? <SalesReport /> : <NotFoundPage />}
                    </RequirePermission>
                } />
                <Route path="/reports/stock" element={
                    <RequirePermission permissions={["REPORTS_READ", "REPORTS_WRITE"]} accessLevels={[AccessLevel.MERCHANT, AccessLevel.ADMIN]}>
                        <ReportsStock />
                    </RequirePermission>
                } />
                <Route path="/software-updates" element={
                    <RequirePermission permissions={["SOFTWARE_UPDATES_READ", "SOFTWARE_UPDATES_WRITE"]} accessLevels={[AccessLevel.ADMIN]}>
                        <SoftwareUpdates />
                    </RequirePermission>
                } />
            </Route>
            <Route path="*" element={<NotFoundPage />} />
        </Routes>
    )
}

export default Routing;